// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ndl4b","field":"styles_field__2KJVp","fieldCol":"styles_fieldCol__3xVr3","diffCol":"styles_diffCol___PuGQ","diff":"styles_diff__zbOkr"};